import { Link, useLocation } from 'react-router-dom';
import { BookOpen, FolderOpen, MessageCircle, Upload, Home, Film } from 'lucide-react';

type NavItem = {
  path: string;
  icon: typeof Home;
  label: string;
  exact?: boolean;
};

const navItems: NavItem[] = [
  { path: '/', icon: Home, label: 'Home', exact: true },
  { path: '/books', icon: BookOpen, label: 'Books' },
  { path: '/videos', icon: Film, label: 'Videos' },
  { path: '/lists', icon: FolderOpen, label: 'Collections' },
  { path: '/chat', icon: MessageCircle, label: 'Librarian' },
  { path: '/upload', icon: Upload, label: 'Upload' },
];

export function BottomNav() {
  const location = useLocation();

  const isActive = (path: string, exact?: boolean) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav" aria-label="Mobile navigation">
      {navItems.map(({ path, icon: Icon, label, exact }) => (
        <Link
          key={path}
          to={path}
          className={`bottom-nav-item ${isActive(path, exact) ? 'active' : ''}`}
          aria-current={isActive(path, exact) ? 'page' : undefined}
        >
          <Icon className="bottom-nav-icon" aria-hidden="true" />
          <span className="bottom-nav-label">{label}</span>
        </Link>
      ))}
    </nav>
  );
}
